import { useEffect } from "react";
import {
    generatePath,
    useNavigate,
    useParams,
    useSearchParams,
} from "react-router-dom";

import { useAppSelector } from "app/hooks";
import { RootState } from "app/store";

export const useReflectUrlParamWithState = <TSelected>(
    selector: (state: RootState) => TSelected,
    onStateUndefinedAndUrlParamDefined: (urlParamValue: string) => void,
    paramName: string,
    urlTemplate: string,
    keepSearchParamsOnNavigate: boolean,
): TSelected => {
    const stateValue = useAppSelector(selector);
    const [searchParams] = useSearchParams();

    const params = useParams();

    const paramValue = params[paramName];

    const navigate = useNavigate();
    useEffect(() => {
        if (stateValue && stateValue !== paramValue) {
            // redirect
            const options: Record<string, string | null | undefined> = {};
            options[paramName] = stateValue as string | null | undefined;

            navigate({
                pathname: generatePath(urlTemplate, options),
                search: keepSearchParamsOnNavigate
                    ? searchParams.toString()
                    : "",
            });
        }

        if (!stateValue && paramValue) {
            onStateUndefinedAndUrlParamDefined(paramValue);
        }
    }, [
        navigate,
        onStateUndefinedAndUrlParamDefined,
        paramName,
        paramValue,
        stateValue,
        urlTemplate,
    ]);

    return stateValue;
};
